import React from "react";

import CollectGraphicsForms from "../forms";
import { FilterModalStandard } from "components/service";

const CollectGraphicsFilterModal = (props) => {
    return (
        <FilterModalStandard
            wrapClass="collect-graphics-filter-modal-wrap"
            modalClass="collect-graphics-filter-modal"
        >
            <CollectGraphicsForms.Filter {...props} />
        </FilterModalStandard>
    );
};

export default CollectGraphicsFilterModal;
